import { Component, ChangeDetectionStrategy } from '@angular/core';

import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-request-password-token',
  standalone: true,
  imports: [ReactiveFormsModule, RouterLink, TranslatePipe],
  templateUrl: './request-password-token.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./request-password-token.component.scss'],
})
export class RequestPasswordTokenComponent {
  emailControl = new FormControl('', {
    validators: [Validators.required, Validators.email],
    nonNullable: true,
  });

  errorMessage: string = '';
  invalidEmail = false;
  working = false;
  rotating = false;
  statusIcon = 'mail';
  statusLabel = 'Envoyer le lien';
  emailSent = false;

  constructor(private authService: AuthService) {}

  get email(): string {
    return this.emailControl.value;
  }

  // Getter pour savoir si le bouton doit être désactivé
  get isButtonDisabled(): boolean {
    return !this.email || this.emailControl.invalid || this.working;
  }

  resetPassword(): void {
    this.invalidEmail = false;

    if (this.emailControl.invalid) {
      this.invalidEmail = true;
      return;
    }

    this.working = true;
    this.rotating = true;
    this.statusLabel = 'Envoi en cours...';

    this.authService.requestPasswordReset(this.emailControl.value).subscribe({
      next: result => {
        if (result.success === true) {
          this.working = false;
          this.rotating = false;
          this.emailSent = true;
          this.statusIcon = 'check_circle';
          this.statusLabel = 'E-mail envoyé !';
        } else {
          this.working = false;
          this.rotating = false;
          this.statusIcon = 'error';

          if (result.message) {
            // Traduire le message d'erreur
            this.errorMessage = result.message;
            this.statusLabel = "Erreur lors de l'envoi";
          } else if (result.retry_after) {
            // Convertir retry_after en minutes et secondes
            const minutes = Math.floor(result.retry_after / 60);
            const seconds = result.retry_after % 60;
            this.errorMessage = `Veuillez patienter ${minutes > 0 ? `${minutes} minute${minutes > 1 ? 's' : ''} et ` : ''}${seconds} seconde${seconds > 1 ? 's' : ''} avant de faire une nouvelle demande.`;
            this.statusLabel = 'Trop de tentatives';
          } else {
            this.errorMessage = '';
            this.statusLabel = "Erreur lors de l'envoi";
          }
        }
      },
    });
  }
}
